import { render } from "./confirmRequests.vue?vue&type=template&id=9a9b5b24&scoped=true"
import script from "./confirmRequests.vue?vue&type=script&lang=js"
export * from "./confirmRequests.vue?vue&type=script&lang=js"

import "./confirmRequests.vue?vue&type=style&index=0&id=9a9b5b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a9b5b24"]])

export default __exports__